<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="createDrawerForm.valid"
    [title]="'synopticPlan.addDrawer' | transloco"
    (onClickEvent)="submit($event)">
    @if (isLoading()) {
        <app-loading />
    } @else if (!drawerOptions.length) {
        <app-no-data-to-display />
    } @else {
        <form [formGroup]="createDrawerForm">
            <div class="flex flex-row item-start w-full mt-6 mb-6">
                <div class="flex flex-col w-80">
                    <app-select
                        [inputFormControl]="createDrawerForm.controls.drawer"
                        [isMultiSelect]="false"
                        [label]="'synopticPlan.drawer' | transloco"
                        [options]="drawerOptions"
                        (optionSelected)="createDrawerForm.controls.drawer.setValue($event[0])" />

                    <app-input-number
                        [inputFormControl]="createDrawerForm.controls.position"
                        [label]="'opticalPath.position' | transloco"
                        [min]="0" />

                    <app-select
                        [inputFormControl]="createDrawerForm.controls.side"
                        [isMultiSelect]="false"
                        [label]="'synopticPlan.drawerSide' | transloco"
                        [options]="sideOptions"
                        (optionSelected)="createDrawerForm.controls.side.setValue($event[0])" />
                </div>
            </div>
        </form>
    }
</app-complex-modal-template>
